import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiZap, FiTrendingUp, FiUsers } = FiIcons;

const Header = () => {
  return (
    <motion.header
      className="glass-effect border-b border-white/20 sticky top-0 z-50"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6">
        <div className="text-center">
          {/* ProActuary Logo - Made smaller and responsive */}
          <motion.div
            className="flex items-center justify-center mb-3 md:mb-4"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <img
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758203824297-Primary-logo-white-on-transparent.png"
              alt="ProActuary"
              className="h-8 md:h-12 w-auto"
            />
          </motion.div>

          <motion.div
            className="flex items-center justify-center mb-2 md:mb-3"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <SafeIcon icon={FiZap} className="text-yellow-400 text-lg md:text-2xl mr-2 animate-pulse-glow" />
            <h1 className="text-xl md:text-3xl lg:text-4xl font-bold text-white">
              AI Actuary Summit 2025
            </h1>
            <SafeIcon icon={FiZap} className="text-yellow-400 text-lg md:text-2xl ml-2 animate-pulse-glow" />
          </motion.div>

          <motion.p
            className="text-sm md:text-lg text-proactuary-blue-200 font-medium"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            Sponsor Performance Dashboard
          </motion.p>

          <motion.div
            className="flex flex-col sm:flex-row items-center justify-center space-y-1 sm:space-y-0 sm:space-x-6 mt-2 md:mt-3 text-white/80"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            <div className="flex items-center space-x-1">
              <SafeIcon icon={FiUsers} className="text-proactuary-green-400 text-sm" />
              <span className="text-xs md:text-sm font-medium">3,321 Registered</span>
            </div>
            <div className="flex items-center space-x-1">
              <SafeIcon icon={FiTrendingUp} className="text-proactuary-blue-400 text-sm" />
              <span className="text-xs md:text-sm font-medium">Global Professional Audience</span>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;